import _ from 'lodash';
export var AutomationTriggerIdentifier = /*#__PURE__*/ function(AutomationTriggerIdentifier) {
    AutomationTriggerIdentifier["ManualTrigger"] = "MANUAL_TRIGGER";
    AutomationTriggerIdentifier["CronTrigger"] = "CRON";
    AutomationTriggerIdentifier["AnyTaskDueDateIsAdded"] = "ANY_TASK_DUE_DATE_IS_ADDED";
    AutomationTriggerIdentifier["AnyTaskDueDateIsRemoved"] = "ANY_TASK_DUE_DATE_IS_REMOVED";
    AutomationTriggerIdentifier["AnyTaskDueDateIsPostponed"] = "ANY_TASK_DUE_DATE_IS_POSTPONED";
    AutomationTriggerIdentifier["AnyTaskDueDateIsPreponed"] = "ANY_TASK_DUE_DATE_IS_PREPONED";
    AutomationTriggerIdentifier["AnyTaskAssigneeIsAdded"] = "ANY_TASK_ASSIGNEE_IS_ADDED";
    AutomationTriggerIdentifier["AnyTaskAssigneeIsRemoved"] = "ANY_TASK_ASSIGNEE_IS_REMOVED";
    AutomationTriggerIdentifier["AnyTaskAssigneeIsCleared"] = "ANY_TASK_ASSIGNEE_IS_CLEARED";
    AutomationTriggerIdentifier["AnyTaskDueDateOverdue"] = "ANY_TASK_DUE_DATE_OVERDUE";
    AutomationTriggerIdentifier["NewMessageInTaskByUserType"] = "NEW_MESSAGE_IN_TASK_BY_USER_TYPE";
    AutomationTriggerIdentifier["ResourceRequestCreated"] = "RESOURCE_REQUEST_CREATED";
    AutomationTriggerIdentifier["ResourceRequestStatusUpdated"] = "RESOURCE_REQUEST_STATUS_IS_UPDATED";
    AutomationTriggerIdentifier["ResourceRequestApproverUpdated"] = "RESOURCE_REQUEST_APPROVER_UPDATED";
    AutomationTriggerIdentifier["BudgetCreated"] = "BUDGET_CREATED";
    AutomationTriggerIdentifier["BudgetFieldUpdated"] = "BUDGET_FIELD_UPDATED";
    AutomationTriggerIdentifier["BudgetDeleted"] = "BUDGET_DELETED";
    AutomationTriggerIdentifier["PhaseProjectFinancialsBudgetsUpdated"] = "PHASE_PROJECT_FINANCIALS_BUDGETS_UPDATED";
    AutomationTriggerIdentifier["TaskProjectFinancialsBudgetsUpdated"] = "TASK_PROJECT_FINANCIALS_BUDGETS_UPDATED";
    /**
   * @deprecated
   */ AutomationTriggerIdentifier["TaskCreated"] = "TASK_CREATED";
    AutomationTriggerIdentifier["TaskCreatedV2"] = "TASK_CREATED_V2";
    AutomationTriggerIdentifier["TaskDeleted"] = "TASK_DELETED";
    AutomationTriggerIdentifier["TaskSpotlighted"] = "TASK_SPOTLIGHTED";
    AutomationTriggerIdentifier["TaskDueDateIsUpdated"] = "TASK_DUE_DATE_IS_UPDATED";
    /**
   * @deprecated
   */ AutomationTriggerIdentifier["TaskStatusIsUpdated"] = "ANY_TASK_STATUS_IS_UPDATED";
    AutomationTriggerIdentifier["TaskStatusIsUpdatedV2"] = "TASK_STATUS_IS_UPDATED_V2";
    /**
   * @deprecated
   */ AutomationTriggerIdentifier["TaskAnyFieldIsUpdated"] = "ANY_TASK_FIELD_IS_UPDATED";
    AutomationTriggerIdentifier["TaskAnyFieldIsUpdatedV2"] = "TASK_ANY_FIELD_IS_UPDATED_V2";
    AutomationTriggerIdentifier["TaskApprovalStatusIsUpdated"] = "TASK_APPROVAL_STATUS_IS_UPDATED";
    AutomationTriggerIdentifier["TaskApprovalRequest"] = "TASK_APPROVAL_REQUEST";
    AutomationTriggerIdentifier["TaskCSATSubmitted"] = "TASK_CSAT_SUBMITTED";
    AutomationTriggerIdentifier["TaskBecomesOverdue"] = "TASK_BECOMES_OVERDUE";
    AutomationTriggerIdentifier["TaskRemainsInCertainStatus"] = "TASK_REMIANS_IN_CERTAIN_STATUS";
    AutomationTriggerIdentifier["NewMessageInTask"] = "NEW_MESSAGE_IN_TASK";
    AutomationTriggerIdentifier["TaskAssigneeIsUpdated"] = "TASK_ASSIGNEE_IS_UPDATED";
    AutomationTriggerIdentifier["TaskDateReachingInXDays"] = "TASK_DATE_REACHING_IN_X_DAYS";
    AutomationTriggerIdentifier["TaskDateCrossedXDays"] = "TASK_DATE_CROSSED_X_DAYS";
    AutomationTriggerIdentifier["TaskDueDateReachingInXDays"] = "TASK_DUE_DATE_REACHING_IN_X_DAYS";
    AutomationTriggerIdentifier["TaskDueDateCrossedXDays"] = "TASK_DUE_DATE_CROSSED_X_DAYS";
    /**
   * @deprecated
   */ AutomationTriggerIdentifier["PhaseCreated"] = "PHASE_CREATED";
    AutomationTriggerIdentifier["PhaseCreatedV2"] = "PHASE_CREATED_V2";
    /**
   * @deprecated
   */ AutomationTriggerIdentifier["PhaseStartDateIsChanged"] = "ANY_PHASE_START_DATE_IS_CHANGED";
    AutomationTriggerIdentifier["PhaseStartDateIsChangedV2"] = "PHASE_START_DATE_IS_CHANGED_V2";
    /**
   * @deprecated
   */ AutomationTriggerIdentifier["PhaseDueDateIsChanged"] = "ANY_PHASE_DUE_DATE_IS_CHANGED";
    AutomationTriggerIdentifier["PhaseDueDateIsChangedV2"] = "PHASE_DUE_DATE_IS_CHANGED_V2";
    /**
   * @deprecated
   */ AutomationTriggerIdentifier["PhaseStatusIsChanged"] = "ANY_PHASE_STATUS_IS_CHANGED";
    AutomationTriggerIdentifier["PhaseStatusIsChangedV2"] = "PHASE_STATUS_IS_CHANGED_V2";
    /**
   * @deprecated
   */ AutomationTriggerIdentifier["PhaseNameIsChanged"] = "PHASE_NAME_IS_CHANGED";
    AutomationTriggerIdentifier["PhaseNameIsChangedV2"] = "PHASE_NAME_IS_CHANGED_V2";
    AutomationTriggerIdentifier["PhaseDeleted"] = "PHASE_DELETED";
    AutomationTriggerIdentifier["DAILY"] = "DAILY";
    AutomationTriggerIdentifier["WEEKLY"] = "WEEKLY";
    AutomationTriggerIdentifier["BiWeekly"] = "BI_WEEKLY";
    AutomationTriggerIdentifier["MONTHLY"] = "MONTHLY";
    AutomationTriggerIdentifier["QUARTERLY"] = "QUARTERLY";
    AutomationTriggerIdentifier["HalfYearly"] = "HALF_YEARLY";
    AutomationTriggerIdentifier["ANNUALLY"] = "ANNUALLY";
    AutomationTriggerIdentifier["DateFieldTrigger"] = "DATE_FIELD_TRIGGER";
    AutomationTriggerIdentifier["FormDueDateIsUpdated"] = "FORM_DUE_DATE_IS_UPDATED";
    AutomationTriggerIdentifier["FormStatusIsUpdated"] = "FORM_STATUS_IS_UPDATED";
    AutomationTriggerIdentifier["FormAssigneeIsUpdated"] = "FORM_ASSIGNEE_IS_UPDATED";
    AutomationTriggerIdentifier["FormAnyFieldIsUpdated"] = "FORM_ANY_FIELD_IS_UPDATED";
    AutomationTriggerIdentifier["FormResponseSubmitted"] = "FORM_RESPONSE_SUBMITTED";
    AutomationTriggerIdentifier["FormCreated"] = "FORM_CREATED";
    AutomationTriggerIdentifier["NewMessageInForm"] = "NEW_MESSAGE_IN_FORM";
    AutomationTriggerIdentifier["FormDeleted"] = "FORM_DELETED";
    AutomationTriggerIdentifier["FormApprovalStatusIsUpdated"] = "FORM_APPROVAL_STATUS_IS_UPDATED";
    AutomationTriggerIdentifier["FormApprovalRequest"] = "FORM_APPROVAL_REQUEST";
    AutomationTriggerIdentifier["FormCSATSubmitted"] = "FORM_CSAT_SUBMITTED";
    AutomationTriggerIdentifier["FormSpotlighted"] = "FORM_SPOTLIGHTED";
    AutomationTriggerIdentifier["ProjectCreated"] = "PROJECT_CREATED";
    AutomationTriggerIdentifier["ProjectAnyFieldIsUpdated"] = "PROJECT_ANY_FIELD_IS_UPDATED";
    AutomationTriggerIdentifier["ProjectFinancialFieldIsUpdated"] = "PROJECT_FINANCIAL_FIELD_IS_UPDATED";
    AutomationTriggerIdentifier["ProjectArchived"] = "PROJECT_ARCHIVED";
    AutomationTriggerIdentifier["ProjectDeleted"] = "PROJECT_DELETED";
    AutomationTriggerIdentifier["CustomerInvitedToProject"] = "CUSTOMER_INVITED_TO_PROJECT";
    AutomationTriggerIdentifier["TeamMemberInvitedToProject"] = "PROJECT_TEAM_MEMBER_IS_INVITED";
    AutomationTriggerIdentifier["ProjectPlaceholderResolved"] = "PROJECT_PLACEHOLDER_RESOLVED";
    AutomationTriggerIdentifier["ProjectCustomerPortalChanged"] = "PROJECT_CUSTOMER_PORTAL_CHANGED";
    AutomationTriggerIdentifier["ProjectNoteCreated"] = "PROJECT_NOTE_CREATED";
    AutomationTriggerIdentifier["ProjectNoteUpdated"] = "PROJECT_NOTE_UPDATED";
    AutomationTriggerIdentifier["ProjectNoteDeleted"] = "PROJECT_NOTE_DELETED";
    AutomationTriggerIdentifier["CompanyNoteCreated"] = "COMPANY_NOTE_CREATED";
    AutomationTriggerIdentifier["CompanyNoteUpdated"] = "COMPANY_NOTE_UPDATED";
    AutomationTriggerIdentifier["CompanyNoteDeleted"] = "COMPANY_NOTE_DELETED";
    AutomationTriggerIdentifier["CompanyAnyFieldIsUpdated"] = "COMPANY_ANY_FIELD_IS_UPDATED";
    AutomationTriggerIdentifier["CompanyCreated"] = "COMPANY_CREATED";
    AutomationTriggerIdentifier["CompanyDeleted"] = "COMPANY_DELETED";
    AutomationTriggerIdentifier["InvoiceMovesFromDraftToInReview"] = "INVOICE_MOVED_FROM_DRAFT_TO_IN_REVIEW";
    AutomationTriggerIdentifier["RowMatchesCondition"] = "ROW_MATCHES_CONDITION";
    AutomationTriggerIdentifier["RowAdded"] = "ROW_ADDED";
    AutomationTriggerIdentifier["RowUpdated"] = "ROW_UPDATED";
    AutomationTriggerIdentifier["RowDeleted"] = "ROW_DELETED";
    AutomationTriggerIdentifier["SheetTabCreated"] = "SHEET_TAB_CREATED";
    AutomationTriggerIdentifier["SheetTabDeleted"] = "SHEET_TAB_DELETED";
    AutomationTriggerIdentifier["SheetTabStatusUpdated"] = "SHEET_TAB_STATUS_UPDATED";
    AutomationTriggerIdentifier["SheetTabAssigneeUpdated"] = "SHEET_TAB_ASSIGNEE_UPDATED";
    AutomationTriggerIdentifier["SheetTabBecomesOverdue"] = "SHEET_TAB_BECOMES_OVERDUE";
    AutomationTriggerIdentifier["SheetCreated"] = "SHEET_CREATED";
    AutomationTriggerIdentifier["SheetDeleted"] = "SHEET_DELETED";
    AutomationTriggerIdentifier["SheetAssigneeUpdated"] = "SHEET_ASSIGNEE_UPDATED";
    AutomationTriggerIdentifier["SheetDueDateUpdated"] = "SHEET_DUE_DATE_UPDATED";
    AutomationTriggerIdentifier["SheetStatusUpdated"] = "SHEET_STATUS_UPDATED";
    AutomationTriggerIdentifier["SheetFieldUpdated"] = "SHEET_FIELD_UPDATED";
    AutomationTriggerIdentifier["SheetApprovalResponseReceived"] = "SHEET_APPROVAL_RESPONSE_RECEIVED";
    AutomationTriggerIdentifier["NewMessageInSheet"] = "NEW_MESSAGE_IN_SHEET";
    AutomationTriggerIdentifier["SheetBecomesOverdue"] = "SHEET_BECOMES_OVERDUE";
    AutomationTriggerIdentifier["SheetManualTrigger"] = "SHEET_MANUAL_TRIGGER";
    AutomationTriggerIdentifier["ExpenseMovedFromDraftToSubmitted"] = "EXPENSE_MOVED_FROM_DRAFT_TO_SUBMITTED";
    AutomationTriggerIdentifier["SignalOccurrenceCreated"] = "SIGNAL_OCCURRENCE_CREATED";
    return AutomationTriggerIdentifier;
}({});
export var AutomationActionIdentifier = /*#__PURE__*/ function(AutomationActionIdentifier) {
    AutomationActionIdentifier["SendEmail"] = "SEND_EMAIL";
    AutomationActionIdentifier["Sleep"] = "SLEEP";
    AutomationActionIdentifier["StoreKeyEventValue"] = "STORE_KEY_EVENT_VALUE";
    AutomationActionIdentifier["CreateTaskMessage"] = "CREATE_TASK_MESSAGE";
    AutomationActionIdentifier["UpdateTaskStartDate"] = "UPDATE_TASK_START_DATE";
    AutomationActionIdentifier["UpdateTaskDueDate"] = "UPDATE_TASK_DUE_DATE";
    AutomationActionIdentifier["UpdateTaskField"] = "UPDATE_TASK_FIELD";
    AutomationActionIdentifier["RequestTaskApproval"] = "REQUEST_TASK_APPROVAL";
    AutomationActionIdentifier["NotifySomeone"] = "NOTIFY_SOMEONE";
    AutomationActionIdentifier["InviteSomeone"] = "INVITE_SOMEONE";
    AutomationActionIdentifier["SendForm"] = "SEND_FORM";
    AutomationActionIdentifier["WebRequest"] = "WEB_REQUEST";
    AutomationActionIdentifier["UpdateTaskStatus"] = "UPDATE_TASK_STATUS";
    AutomationActionIdentifier["UpdateTaskPhase"] = "UPDATE_TASK_PHASE";
    AutomationActionIdentifier["UpdateProjectFields"] = "UPDATE_PROJECT_FIELDS";
    AutomationActionIdentifier["UpdateProjectNoteField"] = "UPDATE_PROJECT_NOTE_FIELD";
    AutomationActionIdentifier["CreateProjectNoteField"] = "CREATE_PROJECT_NOTE";
    AutomationActionIdentifier["UpdateProjectFinancialFields"] = "UPDATE_PROJECT_FINANCIAL_FIELDS";
    AutomationActionIdentifier["ShiftProjectDates"] = "SHIFT_PROJECT_DATES";
    AutomationActionIdentifier["CreateTask"] = "CREATE_TASK";
    AutomationActionIdentifier["CreateSubTask"] = "CREATE_SUB_TASK";
    AutomationActionIdentifier["UpdateTaskAssignee"] = "UPDATE_TASK_ASSIGNEE";
    AutomationActionIdentifier["ShiftTaskDates"] = "SHIFT_TASK_DATES";
    AutomationActionIdentifier["DeleteTask"] = "DELETE_TASK";
    AutomationActionIdentifier["CreateDocument"] = "CREATE_DOCUMENT";
    AutomationActionIdentifier["SendProjectUpdates"] = "SEND_PROJECT_UPDATES";
    AutomationActionIdentifier["ImportTemplate"] = "IMPORT_TEMPLATE";
    AutomationActionIdentifier["CreateProjectMessage"] = "CREATE_PROJECT_MESSAGE";
    AutomationActionIdentifier["UpdateResourceAllocation"] = "UPDATE_RESOURCE_ALLOCATION";
    AutomationActionIdentifier["UpdateProjectStatus"] = "UPDATE_PROJECT_STATUS";
    AutomationActionIdentifier["ArchiveProject"] = "ARCHIVE_PROJECT";
    AutomationActionIdentifier["DeleteProject"] = "DELETE_PROJECT";
    AutomationActionIdentifier["ChangeCustomerPortalForProject"] = "CHANGE_CUSTOMER_PORTAL_FOR_PROJECT";
    AutomationActionIdentifier["UpdatePhaseStartDate"] = "UPDATE_PHASE_START_DATE";
    AutomationActionIdentifier["UpdatePhaseDueDate"] = "UPDATE_PHASE_DUE_DATE";
    AutomationActionIdentifier["UpdatePhaseStatus"] = "UPDATE_PHASE_STATUS";
    AutomationActionIdentifier["DeletePhase"] = "DELETE_PHASE";
    AutomationActionIdentifier["NotifyViaSlack"] = "NOTIFY_VIA_SLACK";
    AutomationActionIdentifier["InviteTeamMember"] = "INVITE_TEAM_MEMBER";
    AutomationActionIdentifier["SendWebRequest"] = "SEND_WEB_REQUEST";
    AutomationActionIdentifier["PushTaskWebHook"] = "PUSH_TASK_WEBHOOK";
    AutomationActionIdentifier["PushProjectWebHook"] = "PUSH_PROJECT_WEBHOOK";
    AutomationActionIdentifier["PushPhaseWebHook"] = "PUSH_PHASE_WEBHOOK";
    AutomationActionIdentifier["PushSignalWebHook"] = "PUSH_SIGNAL_WEBHOOK";
    AutomationActionIdentifier["PushNoteWebHook"] = "PUSH_NOTE_WEBHOOK";
    AutomationActionIdentifier["ExitAutomation"] = "EXIT_AUTOMATION";
    AutomationActionIdentifier["FollowTask"] = "FOLLOW_TASK";
    AutomationActionIdentifier["UpdatePhaseName"] = "UPDATE_PHASE_NAME";
    AutomationActionIdentifier["AssignResourceRequestApprover"] = "ASSIGN_RESOURCE_REQUEST_APPROVER";
    AutomationActionIdentifier["AssignApprovalToInvoice"] = "ASSIGN_APPROVAL_TO_INVOICE";
    AutomationActionIdentifier["SpotlightTask"] = "SPOTLIGHT_TASK";
    AutomationActionIdentifier["DeleteAllocations"] = "DELETE_ALLOCATIONS";
    AutomationActionIdentifier["ShiftAllocations"] = "SHIFT_ALLOCATIONS";
    AutomationActionIdentifier["UpdateCompanyFields"] = "UPDATE_COMPANY_FIELDS";
    AutomationActionIdentifier["UpdateAccountNoteField"] = "UPDATE_ACCOUNT_NOTE_FIELD";
    AutomationActionIdentifier["CreateAccountNoteField"] = "CREATE_ACCOUNT_NOTE";
    AutomationActionIdentifier["CreateSheetTab"] = "CREATE_SHEET_TAB";
    AutomationActionIdentifier["UpdateSheetTabAssignee"] = "UPDATE_SHEET_TAB_ASSIGNEE";
    AutomationActionIdentifier["UpdateSheetAssignee"] = "UPDATE_SHEET_ASSIGNEE";
    AutomationActionIdentifier["UpdateSheetStartDate"] = "UPDATE_SHEET_START_DATE";
    AutomationActionIdentifier["UpdateSheetDueDate"] = "UPDATE_SHEET_DUE_DATE";
    AutomationActionIdentifier["ShiftSheetDates"] = "SHIFT_SHEET_DATES";
    AutomationActionIdentifier["ChangeSheetTabStatus"] = "CHANGE_SHEET_TAB_STATUS";
    AutomationActionIdentifier["FreezeSheetTab"] = "FREEZE_SHEET_TAB";
    AutomationActionIdentifier["UpdateSheetField"] = "UPDATE_SHEET_FIELD";
    AutomationActionIdentifier["RequestSheetTabApproval"] = "REQUEST_SHEET_TAB_APPROVAL";
    AutomationActionIdentifier["RequestSheetApproval"] = "REQUEST_SHEET_APPROVAL";
    AutomationActionIdentifier["DeleteRow"] = "DELETE_ROW";
    AutomationActionIdentifier["DeleteSheet"] = "DELETE_SHEET";
    AutomationActionIdentifier["DeleteSheetTab"] = "DELETE_SHEET_TAB";
    AutomationActionIdentifier["UpdateSheetStatus"] = "UPDATE_SHEET_STATUS";
    AutomationActionIdentifier["UpdateSheetTabDueDate"] = "UPDATE_SHEET_TAB_DUE_DATE";
    AutomationActionIdentifier["AddRow"] = "ADD_ROW";
    AutomationActionIdentifier["UpdateRow"] = "UPDATE_ROW";
    AutomationActionIdentifier["CreateSheetMessage"] = "CREATE_SHEET_MESSAGE";
    AutomationActionIdentifier["FreezeSheet"] = "FREEZE_SHEET";
    AutomationActionIdentifier["FollowSheet"] = "FOLLOW_SHEET";
    AutomationActionIdentifier["AutoApproveExpense"] = "AUTO_APPROVE_EXPENSE";
    AutomationActionIdentifier["AssignApprovalToExpense"] = "ASSIGN_APPROVAL_TO_EXPENSE";
    AutomationActionIdentifier["CreateBudget"] = "CREATE_BUDGET";
    AutomationActionIdentifier["UpdateBudgetField"] = "UPDATE_BUDGET_FIELD";
    return AutomationActionIdentifier;
}({});
export var AutomationSource = /*#__PURE__*/ function(AutomationSource) {
    AutomationSource["ProjectTemplate"] = "PROJECT_TEMPLATE";
    AutomationSource["ProjectPhaseTemplate"] = "PROJECT_PHASE_TEMPLATE";
    AutomationSource["TaskTemplate"] = "TASK_TEMPLATE";
    AutomationSource["None"] = "NONE";
    AutomationSource["GLOBAL"] = "GLOBAL";
    AutomationSource["FormTemplate"] = "FORM_TEMPLATE";
    AutomationSource["GlobalProject"] = "GLOBAL_PROJECT";
    AutomationSource["GlobalProjectPhase"] = "GLOBAL_PROJECT_PHASE";
    AutomationSource["GlobalTask"] = "GLOBAL_TASK";
    AutomationSource["GlobalForm"] = "GLOBAL_FORM";
    AutomationSource["GlobalResourceRequest"] = "GLOBAL_RESOURCE_REQUEST";
    AutomationSource["GlobalProjectFinancialsBudget"] = "GLOBAL_PROJECT_FINANCIALS_BUDGET";
    AutomationSource["GlobalCompany"] = "GLOBAL_COMPANY";
    AutomationSource["GlobalInvoice"] = "GLOBAL_INVOICE";
    AutomationSource["GlobalCreditNote"] = "GLOBAL_CREDIT_NOTE";
    AutomationSource["SheetTemplate"] = "SHEET_TEMPLATE";
    AutomationSource["ExpenseApproval"] = "EXPENSE_APPROVAL";
    AutomationSource["GlobalSignal"] = "GLOBAL_SIGNAL";
    return AutomationSource;
}({});
export const GLOBAL_AUTOMATIONS = [
    "GLOBAL_PROJECT",
    "GLOBAL_TASK",
    "GLOBAL_PROJECT_PHASE",
    "GLOBAL_FORM",
    "GLOBAL_RESOURCE_REQUEST",
    "GLOBAL_SIGNAL",
    "GLOBAL_PROJECT_FINANCIALS_BUDGET",
    "NONE"
];
export var AutomationInputFieldType = /*#__PURE__*/ function(AutomationInputFieldType) {
    AutomationInputFieldType["TASK"] = "TASK";
    AutomationInputFieldType["PROJECT"] = "PROJECT";
    AutomationInputFieldType["ProjectPhase"] = "PROJECT_PHASE";
    AutomationInputFieldType["TaskFieldsSelector"] = "TASK_FIELDS_SELECTOR";
    AutomationInputFieldType["ProjectFieldsSelector"] = "PROJECT_FIELDS_SELECTOR";
    AutomationInputFieldType["ProjectFinancialsBudgetFieldsSelector"] = "PROJECT_FINANCIALS_BUDGET_FIELDS_SELECTOR";
    AutomationInputFieldType["ResourceRequest"] = "RESOURCE_REQUEST";
    AutomationInputFieldType["ProjectFinancialsBudget"] = "PROJECT_FINANCIALS_BUDGET";
    AutomationInputFieldType["ProjectNoteFieldSelector"] = "PROJECT_NOTE_FIELD_SELECTOR";
    AutomationInputFieldType["CompanyNoteFieldSelector"] = "COMPANY_NOTE_FIELD_SELECTOR";
    return AutomationInputFieldType;
}({});
export var AutomationFieldRenderType = /*#__PURE__*/ function(AutomationFieldRenderType) {
    AutomationFieldRenderType["Cron"] = "CRON";
    AutomationFieldRenderType["SingleSelect"] = "SINGLE_SELECT";
    AutomationFieldRenderType["MultiSelect"] = "MULTI_SELECT";
    AutomationFieldRenderType["SimpleSearchFilter"] = "SIMPLE_SEARCH_FILTER";
    AutomationFieldRenderType["RichText"] = "RICH_TEXT";
    AutomationFieldRenderType["MultiSelectPopup"] = "MULTI_SELECT_POPUP";
    AutomationFieldRenderType["LabelBold"] = "LABEL_BOLD";
    AutomationFieldRenderType["Default"] = "_DEFAULT_";
    AutomationFieldRenderType["KeyValuePair"] = "KEY_VALUE_PAIR";
    AutomationFieldRenderType["Toggle"] = "TOGGLE";
    AutomationFieldRenderType["Radio"] = "RADIO";
    AutomationFieldRenderType["Email"] = "EMAIL";
    AutomationFieldRenderType["EmailInput"] = "EMAIL_INPUT";
    AutomationFieldRenderType["Squad"] = "SQUAD";
    AutomationFieldRenderType["AllProjectMembers"] = "ALL_PROJECT_MEMBERS";
    AutomationFieldRenderType["Iso8601PeriodField"] = "ISO_8601_PERIOD_FIELD";
    AutomationFieldRenderType["FormQuestion"] = "FORM_QUESTION";
    AutomationFieldRenderType["DaysSelectorInput"] = "DAYS_SELECTOR_INPUT";
    AutomationFieldRenderType["MessageSenderType"] = "MESSAGE_SENDER_TYPE";
    AutomationFieldRenderType["NoWebhooksFound"] = "NO_WEBHOOKS_FOUND";
    /**
   * @deprecated
   */ AutomationFieldRenderType["ComposeEmail"] = "COMPOSE_EMAIL";
    AutomationFieldRenderType["TemplatePicker"] = "TEMPLATE_PICKER";
    AutomationFieldRenderType["ObjectSelector"] = "OBJECT_SELECTOR";
    AutomationFieldRenderType["MultipleObjectsSelector"] = "OBJECTS_SELECTOR";
    AutomationFieldRenderType["EmailCompose"] = "EMAIL_COMPOSE";
    AutomationFieldRenderType["Effort"] = "EFFORT_FIELD";
    AutomationFieldRenderType["TimesheetHoursField"] = "TIMESHEET_HOURS_FIELD";
    AutomationFieldRenderType["ConnectToSlack"] = "CONNECT_TO_SLACK";
    AutomationFieldRenderType["JsonEditor"] = "JSON_EDITOR";
    AutomationFieldRenderType["ScheduleRepeatPicker"] = "SCHEDULE_REPEAT_PICKER";
    AutomationFieldRenderType["ScheduleStartPicker"] = "SCHEDULE_START_PICKER";
    return AutomationFieldRenderType;
}({});
export var FilterContext = /*#__PURE__*/ function(FilterContext) {
    FilterContext[FilterContext["Automations"] = 0] = "Automations";
    FilterContext[FilterContext["Others"] = 1] = "Others";
    return FilterContext;
}({});
export const isValueMetaStringOrNumber = (m)=>_.isString(m) || _.isNumber(m);
export var AutomationFieldRenderParams = /*#__PURE__*/ function(AutomationFieldRenderParams) {
    AutomationFieldRenderParams["ShowUsers"] = "SHOW_USERS";
    AutomationFieldRenderParams["ShowTeams"] = "SHOW_TEAMS";
    AutomationFieldRenderParams["ShowProjectOwner"] = "SHOW_PROJECT_OWNER";
    AutomationFieldRenderParams["ShowAllProjectMembers"] = "SHOW_ALL_PROJECT_MEMBERS";
    AutomationFieldRenderParams["ShowCustomerProjectMembers"] = "SHOW_CUSTOMER_PROJECT_MEMBERS";
    AutomationFieldRenderParams["ShowInternalProjectMembers"] = "SHOW_INTERNAL_PROJECT_MEMBERS";
    AutomationFieldRenderParams["ShowTimesheetApprovers"] = "SHOW_TIMESHEET_APPROVERS";
    AutomationFieldRenderParams["ShowInvitedUserEmail"] = "SHOW_INVITED_USER_EMAIL";
    AutomationFieldRenderParams["HorizontalRadio"] = "HORIZONTAL_RADIO";
    AutomationFieldRenderParams["VerticalRadio"] = "VERTICAL_RADIO";
    AutomationFieldRenderParams["Bold"] = "BOLD";
    AutomationFieldRenderParams["SimpleVariable"] = "SIMPLE_VARIABLE";
    AutomationFieldRenderParams["ConditionalVariable"] = "CONDITIONAL_VARIABLE";
    AutomationFieldRenderParams["Emojis"] = "EMOJIS";
    AutomationFieldRenderParams["Checkbox"] = "CHECKBOX";
    AutomationFieldRenderParams["Images"] = "IMAGES";
    AutomationFieldRenderParams["ShowDays"] = "SHOW_DAYS";
    AutomationFieldRenderParams["ShowWeeks"] = "SHOW_WEEKS";
    AutomationFieldRenderParams["ShowMonths"] = "SHOW_MONTHS";
    AutomationFieldRenderParams["LimitText"] = "LIMIT_TEXT";
    AutomationFieldRenderParams["AllowSmartFills"] = "ALLOW_SMART_FILLS";
    AutomationFieldRenderParams["ShowCustomUsers"] = "SHOW_CUSTOM_USERS";
    AutomationFieldRenderParams["ShowCompanyTeams"] = "SHOW_COMPANY_TEAMS";
    return AutomationFieldRenderParams;
}({});
